<template>
  <div class="approveBox">
    <qx-card title="申请信息">
      <qx-custom-form
        :noSubBtn="true"
        ref="baseForm"
        :formData="baseForm"
      >
        <section slot="applyUser" slot-scope="prop">
          <ChooseWorker :isRadio="true" v-model="prop.form.applyUser" />
        </section>
        <section slot="car" slot-scope="prop">
          <ChooseCar
            v-model="prop.form.car"
          />
        </section>
      </qx-custom-form>
      <SubBtnBox @sub="sub" />
    </qx-card>
  </div>
</template>

<script>
import SubBtnBox from 'components/subBtnBox';
import ChooseWorker from 'components/choose/worker';
import ChooseCar from 'components/choose/car';
import {
  oilCardApply,
} from 'api/service';
export default {
  components: {
    SubBtnBox,
    ChooseWorker,
    ChooseCar,
  },
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '申请人',
            value: 'applyUser',
            default: {},
            slot: true,
          },
          // {
          //   label: '手机号',
          //   value: 'applyUserPhone',
          //   type: 'input',
          // },
          {
            label: '申请张数',
            value: 'car',
            default: [],
            slot: true,
          },
          {
            label: '信用资料',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 100,
            },
            default: [],
          },
          {
            label: '备注',
            value: 'applyRemark',
            type: 'input',
            width: '430px',
            attr: {
              type: 'textarea',
              limit: 300,
            },
          },
        ],
        rules: {
          applyUser: [ // 申请人
            { required: true, message: '请选择申请人', trigger: 'blur' },
          ],
          car: [ // 申请张数
            { required: true, message: '请选择申请张数', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (this.customPost) {
        this.$emit('sub', formData);
        return;
      }
      if (formData) {
        // 员工信息
        formData.applyUserId = formData.applyUser.userId;
        formData.applyUserPhone = formData.applyUser.loginAcct;
        formData.applyUserName = formData.applyUser.linkman;
        delete formData.applyUser;
        // 车辆信息
        formData.applyOilCount = formData.car.length;
        formData.vehicleCodes = formData.car.map((item) => item.vehicleCode);
        formData.vehicleCodes = formData.vehicleCodes.join(',');
        delete formData.car;
        // 文件
        formData.file.forEach((item, index) => {
          formData[`fileId${index + 1}`] = item.id;
          formData[`fileUrl${index + 1}`] = item.url;
        });
        delete formData.file;
        let res = await oilCardApply({
          ...formData,
          isNeedBill: 1,
          productId: this.$route.query.productId,
          isShare: this.$route.query.isShare,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.close();
        }
      }
    },
  },
  // created () {
  //   this.tableData.data = [{customerCode: 123}];
  // },
};
</script>

<style scoped lang="scss">
.approveBox{
  padding-bottom: 56px;
}
</style>
